import { useLocation, useNavigate } from 'react-router-dom';

export function SectionLink({ id, className, children, onClick, ...props }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <a
      href={`/#${id}`}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        if (location.pathname === '/') {
          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        } else {
          navigate({ pathname: '/', hash: id });
        }
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </a>
  );
}
